/**
 * Staging Environment
 */
export const environment = {
  version: '0.3.1',
  env: 'staging',
  production: false,
  userPoolId: 'us-east-1_Outx79wat', // ps-playground
  clientId: '38heq46r2nqrljo2ochv44prc', // ps-playground
  username: '',
  password: '',
  passThroughAPI:
    'https://pass-through.ps-smartfeed.cloud.petsafe.net:8083', // production working
  directoryAPI:
    'https://ibdadxapsb.execute-api.us-east-1.amazonaws.com/staging',
  // 'https://k5dqp5fkhh.execute-api.us-east-1.amazonaws.com/staging', // staging working
  provisioningAPI:
    'https://erv0e0ujgk.execute-api.us-east-1.amazonaws.com/staging', // staging
  petAPI:
    'https://ziy59xeq19.execute-api.us-east-1.amazonaws.com/staging', // staging
  productAPI:
    'https://k1wfun7p3a.execute-api.us-east-1.amazonaws.com/staging', // staging working
  remindersAPI:
    'https://v614iyker9.execute-api.us-east-1.amazonaws.com/staging', // staging
  notificiationAPI:
    'https://brnqejiut3.execute-api.us-east-1.amazonaws.com/staging', // staging
  ccApiKey: 'GuViC9KaDh6xvRgujoP9kFubtvNuSIs9CoDNfr10',
  customerCareAPI:
    'https://ibdadxapsb.execute-api.us-east-1.amazonaws.com/staging',
  redirectSignIn:
    'https://staging.ccplatform.cloud.petsafe.net/login',
  redirectSignOut:
    'https://staging.ccplatform.cloud.petsafe.net/login',
  region: 'us-east-1',
  log: {
    message: true,
    debug: true,
    error: true,
  },
};
